import React from 'react';
import {MENU_IDS} from '../../../constants/menuIds';
import {ISlide} from '../../../incase-domain/slide';
import {ContextMenuTrigger} from '../../../incase-domain/components/contextMenu/ContextMenu';

interface SlidePreviewContextMenuTriggerProps {
    slide: ISlide | undefined;
    mutateSlide: (cb?: () => void) => void;
}

export function SlidePreviewContextMenuTrigger({
    slide,
    mutateSlide,
    children,
}: React.PropsWithChildren<SlidePreviewContextMenuTriggerProps>): JSX.Element | null {
    if (!slide) return <>{children}</>;

    return (
        <ContextMenuTrigger menuId={MENU_IDS.SLIDE_PREVIEW} menuProps={{slide, mutateSlide}}>
            {children}
        </ContextMenuTrigger>
    );
}

export default SlidePreviewContextMenuTrigger;
